import type { JSX } from "react";
import { ContextPanel } from "../../agent/ContextPanel";
import { AgentStatsRegionConnected } from "../../agent/AgentStatsRegion";
import { useEpisodeDetailQuery } from "./queries";
import { buildContextPanelProps, getSourceVisual } from "./helpers";
import { schemaIdToModuleId } from "../../agent/schemaIdToModuleId";
import type { RightPaneProps } from "../_base/types";

export function EpisodeContextPane({
  selectedId,
  runtime,
}: RightPaneProps): JSX.Element | null {
  const uuid = selectedId?.startsWith("agent:") ? selectedId.slice(6) : selectedId;
  const { data: episode } = useEpisodeDetailQuery(uuid);

  if (!selectedId || !episode) return null;

  // Plan #8: derive source visuals from started_with schema_id, not context_key.
  const startedWith = episode.linked_entities.find((e) => e.link_kind === "started_with");
  const sourceModuleId = schemaIdToModuleId(startedWith?.schema_id);
  const visuals = getSourceVisual(sourceModuleId);

  const contextProps = buildContextPanelProps(
    {
      id: `agent:${episode.id}`,
      title: episode.title,
      preview: "",
      time: "",
      activityAt: null,
      iconName: visuals.icon,
      color: visuals.color,
      sourceModuleId,
      targetModuleId: sourceModuleId,
      targetItemId: startedWith?.id ?? episode.id,
    },
    episode.linked_entities,
  );

  return (
    <ContextPanel
      {...contextProps}
      runtime={runtime}
      bottomSlot={
        <AgentStatsRegionConnected
          runtime={runtime}
          contextKey={episode.id}
          episodeId={episode.id}
        />
      }
    />
  );
}
